import { useState } from 'react';
import { Alert, App, Button, Card, Space, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { packApi } from '../api/packApi';
import { PackForm } from '../components/PackForm';
import { packErrorMessage } from '../utils/errors';
import { toCreatePackBody, type PackFormValues } from '../utils/packForm';

/**
 * Página de alta de Pack de Energía (`/packs/nuevo`, solo `SUPER_ADMIN` — el guard
 * de la ruta lo garantiza). El pack nace ACTIVE y con moneda COP por defecto.
 */
export function CreatePackPage() {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const goToList = () => navigate('/packs');

  const handleSubmit = async (values: PackFormValues) => {
    setSubmitting(true);
    setError(null);
    try {
      const created = await packApi.create(toCreatePackBody(values));
      message.success('Pack creado.');
      navigate(`/packs/${encodeURIComponent(created.id)}`);
    } catch (caught) {
      setError(packErrorMessage(caught, 'No se pudo crear el pack.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="packs-page">
      <div className="packs-page__header">
        <Space align="center">
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            aria-label="Volver al listado de packs"
            onClick={goToList}
          >
            Volver
          </Button>
          <Typography.Title level={3} style={{ margin: 0 }}>
            Nuevo pack
          </Typography.Title>
        </Space>
      </div>

      {error && (
        <Alert
          type="error"
          showIcon
          role="alert"
          message="No se pudo crear el pack"
          description={error}
        />
      )}

      <Card>
        <PackForm mode="create" submitting={submitting} onSubmit={handleSubmit} onCancel={goToList} />
      </Card>
    </div>
  );
}
